import {
  Body1,
  Caption1,
  NavDrawerBody,
  NavDrawerHeader,
  NavItem,
  Subtitle2,
} from '@fluentui/react-components'

import { Translate24Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { useNotification } from '../../../hooks'
import { useSettingsStyles } from '../settingsStyles'

// Native names never localize, so they're inlined here. The English subtitle
// reuses the existing settings.{value} key forced to 'en' via the lng option.
const LANGUAGES = [
  { value: 'zh', native: '中文（普通话）' },
  { value: 'en', native: 'English' },
  { value: 'ja', native: '日本語' },
]

type LanguageSubmenuProps = {
  onClose?: () => void
}

const LanguageSubmenu = ({ onClose }: LanguageSubmenuProps) => {
  const { i18n, t } = useTranslation()
  const { notify } = useNotification()
  const styles = useSettingsStyles()

  const changeLanguage = async (lang: string) => {
    await i18n.changeLanguage(lang)
    // t from i18n instance to have the new language in the notification text
    notify({ isSuccess: true, text: i18n.t('settings.languageUpdated'), position: 'top' })
    onClose?.()
  }

  return (
    <>
      <NavDrawerHeader className={styles.submenuHeader}>
        <Translate24Regular />
        <Subtitle2 as="h2">{t('settings.language')}</Subtitle2>
      </NavDrawerHeader>
      <NavDrawerBody>
        {LANGUAGES.map((lang) => (
          <NavItem
            key={lang.value}
            value={lang.value}
            className={styles.languageItem}
            onClick={() => changeLanguage(lang.value)}>
            <span className={styles.languageItemTextContainer}>
              <Body1 as="span">{lang.native}</Body1>
              <Caption1 as="span">{t(`settings.${lang.value}`, { lng: 'en' })}</Caption1>
            </span>
          </NavItem>
        ))}
      </NavDrawerBody>
    </>
  )
}

export { LanguageSubmenu }
